import { useState, useEffect } from 'react';
import {
  PersonalInformationApiElementContentModel,
  PersonalInformationScreenContentModel,
  PersonalInformationScreenPropertiesModel,
  MeDto,
} from '@/services/platform/api/model';
import { cn, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { getUserProfile, updateProfile, uploadProfilePhoto } from '@/services/platform/data/profile';
import { SpinLoading } from '@/components/shared/loadings/spin';
import { ProfileAccountPersonalInformation } from '@/components/shared/profile/account/personal-information';

export const PersonalInformationApi = (props: ModuleProperties) => {
  const content = props.content as PersonalInformationApiElementContentModel | undefined;
  const [profile, setProfile] = useState<MeDto | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserProfile()
      .then(data => setProfile(data))
      .catch(() => setProfile(undefined))
      .finally(() => setLoading(false));
  }, []);

  const page = props.context?.page as PersonalInformationScreenContentModel;
  const pageProperties = page?.properties as PersonalInformationScreenPropertiesModel;

  if (!content) return null;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__personal-information-api']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      {loading ? (
        <SpinLoading wrapperClassName="min-h-[30vh]" />
      ) : (
        <ProfileAccountPersonalInformation
          profile={profile}
          pageProperties={pageProperties}
          appSettings={props.context?.settings}
          onSave={async data => {
            const updated = await updateProfile(data);
            if (updated) setProfile(updated);
          }}
          onPhotoUpload={async file => {
            const base64 = await new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve((reader.result as string).split(',')[1]);
              reader.onerror = reject;
              reader.readAsDataURL(file);
            });
            const updated = await uploadProfilePhoto({ imageBase64: base64, contentType: file.type });
            if (updated) setProfile(updated);
          }}
        />
      )}
    </ModuleWrapper>
  );
};
